<div>
    <div class="heading-6" v-if="companyName">
        <aeg-company-info :name="companyName" :identifier="identifier" />
    </div>

    <div v-if="readOnly">
        <div>
            <aeg-address-details :service="service" />
            <Button
                variant="link"
                icon="pi pi-pencil"
                label="Aanpassen"
                @click.prevent="toggleReadOnly"
                class="p-px!"

            />
        </div>
    </div>
    <div v-else style="display: flex; flex-direction: column; gap: 1rem;">
        <div v-if="showVatNumber" style="margin-bottom: 1rem;">
            <aeg-field-validation-wrapper :error-message="errors.vatNumber" name="BTW-nummer" mod-required #default="{hasErrors}">
                <InputText name="vatNumber" v-model="vatNumber" v-bind="vatNumberProps" :invalid="hasErrors" />
            </aeg-field-validation-wrapper>
        </div>
        <h6 class="heading-6" style="margin-bottom: 0;" v-if="!isCitizen">Adres van de maatschappelijke zetel</h6>
        <h6 class="heading-6" style="margin-bottom: 0;" v-else>{{fullName}}</h6>
        <div style="display: flex; gap: 1rem; flex-wrap: wrap;">
            <div style="flex-grow: 1; min-width:20em; ">
                <aeg-field-validation-wrapper :error-message="errors.street" name="Straat" mod-required #default="{hasErrors}">
                    <AutoComplete
                        :suggestions="streetData"
                        :loading="streetDataFetching"
                        name="straat"
                        v-model="streetWrapper"
                        option-label="title"
                        :invalid="hasErrors"
                        fluid
                        scrollHeight="30rem"
                        :dropdown="true"
                        dropdown-mode="current"
                        @dropdown-click="onStreetDropdownClick"
                    >
                        <template #option="slotProps">
                            <div class="flex flex-col">
                                <div>{{slotProps.option.title}}</div>
                                <div class="font-light">{{slotProps.option.subtitle}}</div>
                            </div>
                        </template>
                    </AutoComplete>
                </aeg-field-validation-wrapper>
            </div>
            <div style="display: flex; gap: 1rem; ">
                <div style="flex-grow: 1; min-width: 7em;">
                    <aeg-field-validation-wrapper :error-message="errors.houseNumber" name="Nummer" mod-required #default="{hasErrors}">
                        <AutoComplete
                            :suggestions="houseNumberData"
                            :min-length="0"
                            :loading="houseNumberDataFetching"
                            name="nummer"
                            v-model="houseNumberWrapper"
                            option-label="title"
                            :invalid="hasErrors"
                            fluid
                            :dropdown="true"
                            dropdown-mode="current"
                            @dropdown-click="onHouseNumberDropdownClick"
                        />
                    </aeg-field-validation-wrapper>
                </div>
                <div style="flex-grow: 1; min-width: 7em;">
                    <aeg-field-validation-wrapper :error-message="errors.boxNumber" name="Bus" #default="{hasErrors}">
                        <InputText name="boxNumber" v-model="boxNumber" v-bind="boxNumberProps" :invalid="hasErrors" />
                    </aeg-field-validation-wrapper>
                </div>
            </div>
        </div>
        <div style="display: flex; flex-direction: row; gap: 1rem; margin-bottom: 1rem; flex-wrap: wrap;">
            <div style="width: 7em;">
                <aeg-field-validation-wrapper :error-message="errors.postalCode" name="Postcode" mod-required #default="{hasErrors}">
                    <InputText name="postalCode" v-model="postalCode" v-bind="postalCodeProps" :invalid="hasErrors" />
                </aeg-field-validation-wrapper>
            </div>
            <div style="flex-grow: 2">
                <aeg-field-validation-wrapper :error-message="errors.city" name="Gemeente" mod-required #default="{hasErrors}">
                    <InputText name="city" v-model="city" v-bind="cityProps" :invalid="hasErrors" />
                </aeg-field-validation-wrapper>
            </div>
            <div style="flex-grow: 1">
                <aeg-field-validation-wrapper :error-message="errors.country" name="Land" mod-required #default="{hasErrors}">
                    <Select filter name="country" :options="countryOptions.map(c => c.name)" v-model="country" :invalid="hasErrors" placeholder="Kies een land" />
                </aeg-field-validation-wrapper>
            </div>
        </div>
        <div v-if="emails.length > 1">
            <h6 class="heading-6">E-mails facturatie</h6>
            <div>
                <p class="body-text-small">{{multipleEmailsDescription}}</p>
            </div>
        </div>
        <div v-if="showEmail" v-for="(field, index) in emails" :key="field.key">
            <aeg-field-validation-wrapper :error-message="errors[`emails[${index}].email`]" :name="`E-mail facturatie ${field.value.service}`" mod-required #default="{hasErrors}"
                                          :annotation="!isCitizen && emails.length === 1 ? annotation : ''">
                <InputText name="email" v-model="field.value.email" :invalid="hasErrors" mod-block />
            </aeg-field-validation-wrapper>
        </div>
    </div>
</div>
